export default "__VITE_ASSET__my6wPa4N__"